module.exports = __webpack_public_path__ + "static/img/pay-error.dcbe40bb.png";